import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import BasicFilterDropdown from '../BasicFilterDropdown/BasicFilterDropdown';
import '../../../../../../scss/weekpicker.css';
import '../../../../../../scss/modernDatePicker.css';
import CustomCalendarPicker from '../../../../CustomWeekPicker/CustomCalendarPicker';
import classes from './WeekFilter.module.scss';
import { calendarTypes, responsiveSizeTimesheet } from '../../../../../../utils/constants';
import MainButton from '../../../../buttons/MainButton';
import { useWindowSize } from '../../../../../../utils/hooks';
import { generalEnums } from '../../../../../../utils/enums';
import colors from '../../../../../../scss/colors';
import { buttonVariants } from '../../../../buttons/types';

export default function WeekFilter({
  daysAvailability = [],
  week = '',
  changeWeek,
  dateBackAction,
  dateForwardAction
}) {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(dayjs());
  const { t } = useTranslation();
  const size = useWindowSize();

  const handleFilterToggle = () => {
    setOpen(!open);
    dateBackAction(date || dayjs().format(generalEnums.DATEFORMAT));
  };

  return (
    <BasicFilterDropdown
      type={t('dashboard.timesheets.filters.week')}
      text={t('dashboard.timesheets.filters.week')}
      active={!!week}
      open={open}
      setOpen={handleFilterToggle}
      sxBox={{
        padding: '36px 0 22px 0'
      }}
      extraHeader={{
        enabled: !!week,
        label: t('common.filters.reset'),
        action: () => {
          changeWeek('');
          setOpen(false);
        }
      }}
    >
      <div className={classes.container}>
        <CustomCalendarPicker
          dateDisablingAbility
          daysAvailability={daysAvailability}
          userDate={!week ? null : dayjs(week)}
          setUserDate={(day) => {
            changeWeek(
              dayjs(day.toString())
                .add(1 - day.getDay(), 'day')
                .format('DD-MMM-YYYY')
            );
            setDate(
              dayjs(day.toString())
                .add(1 - day.getDay(), 'day')
                .format(generalEnums.DATEFORMAT)
            );
            setOpen(false);
          }}
          calendarType={calendarTypes.WEEK}
          dateBackAction={dateBackAction}
          dateForwardAction={dateForwardAction}
        />
        {week && size.width > responsiveSizeTimesheet && (
          <MainButton
            outlined
            rounded
            variant={buttonVariants.TERNARY}
            size={size.width < responsiveSizeTimesheet ? 'small' : 'xsmall'}
            forceWidth={size.width < responsiveSizeTimesheet ? '100%' : '136px'}
            action={() => {
              changeWeek('');
              setOpen(false);
            }}
            sx={{
              color: colors.MEDIUM_GREY,
              borderColor: colors.MEDIUM_GREY
            }}
          >
            <p>{t('dashboard.timesheets.filters.reset')}</p>
          </MainButton>
        )}
      </div>
    </BasicFilterDropdown>
  );
}
